<template>
  <div class="text-collapse-container" @click="toggle">
    <div class="text-collapse-text">
      <div v-if="type && type === 'park'" ref="content" :class="['content', { 'hide-park': flag && !isShowAll }]">
        <slot />
      </div>
      <div v-else ref="content" :class="['content', { hide: flag && !isShowAll }]">
        <slot />
      </div>
    </div>
    <div v-if="flag" class="text-collapse-btn">
      <span>{{ isShowAll ? '收起' : '查看更多' }}</span>
      <base-icon :class="!isShowAll ? 'icon' : 'icon icon-up'" name="position_arrow_hl" />
    </div>
  </div>
</template>

<style lang="less">
.text-collapse-text {
  .content {
    font-size: 28px;
    line-height: 48px;
    color: #444;
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap;
    &.hide {
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 8;
      -webkit-box-orient: vertical;
    }
    &.hide-park {
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}

.text-collapse-btn {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 26px;
  color: #ff6000;
  margin-top: 10px;
  .icon {
    display: block;
    width: 32px;
    height: 32px;
    margin-left: 5px;
    position: relative;
    transform: rotate(0);
  }
  .icon-up {
    transform: rotate(180deg);
  }
}
</style>

<script>
export default {
  name: 'BaseTextCollapse',
  props: {
    type: String,
  },
  data() {
    return {
      isShowAll: false,
      flag: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      const contentEl = this.$refs.content;
      const length = this.type && this.type === 'park' ? 72 : 192
      if (contentEl.offsetHeight > length || contentEl.clientHeight > length) {
        this.flag = true;
      }
    });
  },
  methods: {
    toggle() {
      this.isShowAll = !this.isShowAll;
    },
  },
};
</script>
